import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DeadLetterDetail } from '../../models/dead-letter-detail.model';

@Component({
    selector: 'app-dead-letter-detail-overview',
    templateUrl: './dead-letter-detail-overview.component.html',
    styleUrls: ['./dead-letter-detail-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterDetailOverviewComponent {
  @Input() detail!: DeadLetterDetail;
  @Input() expanded = true;
  @Output() expandedChange = new EventEmitter<boolean>();
}